import { useEffect, useState } from 'react';

/**
 * Hook to detect if the user is navigating using keyboard (Tab key)
 * Returns true when user presses Tab, false when user clicks with mouse
 */
export const useIsKeyboardNavigation = () => {
  const [isKeyboardUser, setIsKeyboardUser] = useState(false);

  useEffect(() => {
    // Set keyboard navigation to true only when Tab key is pressed
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        setIsKeyboardUser(true);
      }
    };

    // Reset keyboard navigation when mouse is used
    const handleMouseDown = () => setIsKeyboardUser(false);

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return isKeyboardUser;
};
